/*
	OneVideo 2.0.0 Usage (Webpack)
	Yang @onerockwell
*/

// Import all dependencies here
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import Player from '@vimeo/player';

import '../../styles/modules/oneVideo.scss';

// Define the Backbone View here (Optional)
let OneVideoView = Backbone.View.extend({
	
	initialize: function (settings) {
		var self = this;
		self.$videoBoxes = self.$el;
		self.isResponsive = settings.isResponsive || false;
		self.bgVideo = settings.bgVideo || false;
		self.autoplay = settings.autoplay || false;
		
		self.initVideos();
	},

	events: {

	},
	
	initVideos: function() {
		var self = this;
		var resizeTimer;

		self.initVisibleVideos();

		// Wrappers hidden by a breakpoint class (desktop/mobile pairs) are skipped
		// above. Re-check on resize so a wrapper that becomes visible loads its
		// video, and one that becomes hidden stops playing in the background.
		$(window).on('resize', function(){
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function(){
				self.initVisibleVideos();
			}, 250);
		});
	},

	isHidden: function(box) {
		return window.getComputedStyle(box).display === 'none';
	},

	initVisibleVideos: function() {
		var self = this;

		_.each(self.$videoBoxes, function(box){
			var $box = $(box);
			var video = $box.find('video')[0];

			if(self.isHidden(box)){
				if(video && !video.paused){
					video.pause();
					$box.data('onevideo-paused-hidden', true);
				}
				return;
			}

			if($box.data('onevideo-initialized')){
				if(video && $box.data('onevideo-paused-hidden')){
					$box.removeData('onevideo-paused-hidden');
					if(self.autoplay){
						var playPromise = video.play();
						if(playPromise && playPromise.catch){
							playPromise.catch(function(){});
						}
					}
				}
				return;
			}
			$box.data('onevideo-initialized', true);

			var boxId = $box.attr('id');
			var type = $box.data('video-type');
			var videoId = $box.data('video-id');
			var videoSrc = $box.data('video-src');
			var videoSection = $box.data('video-section');
			var videoPoster = $box.data('video-poster');
			
			if(self.bgVideo){
				self.loadHostPlayer(videoId,videoSrc,$box,boxId,videoSection,videoPoster);
			}else if(type == "vimeo"){
				self.loadVimeoPlayer(videoId,videoSrc,$box,boxId);
			}
		});
	},
	
	loadHostPlayer: function(video_id,video_src,$video_box,video_box_id,videoSection,videoPoster){
		// Works for vimeo or self-hosted videos
		var self = this, id = '', $videoWrapper = $video_box;
		var videoRatio = $videoWrapper.data('ratio') ? $videoWrapper.data('ratio') : 0.6; // 0.6 is default for product video
		var $playerCtl = $videoWrapper.find('.video-ctl');
		let is_inview = false, can_play = false, metadata_loaded = false, has_paused = false;

		var responsive = function(r){
			var wrapperRatio = $videoWrapper.width()/$videoWrapper.height();
			if (wrapperRatio >= r) {
				$videoWrapper.find('video').css({
					'width' : '100%',
					'height': $videoWrapper.width()/r
				});
			} else {
				$videoWrapper.find('video').css({
					'height' : '100%',
					'width': $videoWrapper.height()*r
				});
			}
		};
		
		if(videoPoster != undefined)
		{
			if(self.autoplay){
				var $video = $('<video preload="metadata" loop muted autoplay playsinline poster="'+videoPoster+'"><source src="' + video_src + '" type="video/mp4"></video>');
			}else{
				var $video = $('<video preload="metadata" loop muted playsinline poster="'+videoPoster+'"><source src="' + video_src + '" type="video/mp4"></video>');
			}
		}
		else
		{
			if(self.autoplay){
				var $video = $('<video preload="metadata" loop muted autoplay playsinline><source src="' + video_src + '" type="video/mp4"></video>');
			}else{
				var $video = $('<video preload="metadata" loop muted playsinline><source src="' + video_src + '" type="video/mp4"></video>');
			}
		}
		$playerCtl.text('Play');
		$video_box.prepend($video);
		
		var theVideo = $video[0]; 
		theVideo.muted = true;

		$('.video-wrapper .muted').on('click',function(){
			theVideo.muted =  false;
			$(this).hide();
			$('.video-wrapper .unmuted').show();
		});

		$('.video-wrapper .unmuted').on('click',function(){
			theVideo.muted =  true;
			$(this).hide();
			$('.video-wrapper .muted').show();
		});

		function setVideoHeight(video_id, height)
		{
			if($(window).width()>768)
			{
				if(video_id.indexOf('desktop')>-1)
				{
					$('.video-wrapper.bg-video[data-video-id="'+video_id+'"]').closest('.section-with-video').css({'height':height+'px'});
				}
			}
			else
			{
				if(video_id.indexOf('mobile')>-1)
				{
					setTimeout(function() {
						var mobile_video_height	= height + $('.video-wrapper.bg-video[data-video-id="'+video_id+'"]').siblings('.inner-wrapper').outerHeight(true);
					
						$("#style-"+video_id).remove();

						$("head").append(`
							<style id="style-${video_id}">
							@media screen and (max-width: 768px) {
								#first-section.fix-height-${video_id}{height: ${mobile_video_height}px !important}
							}
							</style>
						`);
												
						$('.video-wrapper.bg-video[data-video-id="'+video_id+'"]').closest('.section-with-video').addClass(`fix-height-${video_id}`);
					},500);
				}
			}
		}

		$(window).on( "resize", function() {
			if(video_id!='')
			{
				var video_height= (theVideo.videoHeight/theVideo.videoWidth)*$(window).width();
				setVideoHeight(video_id, video_height);
			}
		});

		$video.on('loadedmetadata', function() {
			metadata_loaded = true;
			$('.video-wrapper').addClass('loaded');

			if(video_id!='')
			{
				var video_height= (theVideo.videoHeight/theVideo.videoWidth)*$(window).width();
							
				$('.video-wrapper.bg-video[data-video-id="'+video_id+'"]').closest('.section-with-video').css({'padding-top':0});
				setVideoHeight(video_id, video_height);
			}
			hideControls();
			
			
			//console.log(`video ${video_id} loaded`);
		})
		$video.on('canplay', function() {
			can_play = true;
			// console.log(`video ${video_id} canplay`);
		})
		$video.on('play', function() {
			$playerCtl.text('Pause');
			$playerCtl.removeClass('paused').addClass('playing');
			$video.isPlaying = true;
			$video_box.find('video').css({
				'visibility': 'visible',
				'opacity': '1'
			});
			// Sync thumbnail button
			var slideIndex = $videoWrapper.closest('.image-slide').data('index');
			if (slideIndex) {
				$('.image-thumbnail[data-index=' + slideIndex + '] .video-ctl-thumbnail').removeClass('paused').addClass('playing');
			}
			console.log('Video playing!');
		});
		$video.on('pause', function() {
			$playerCtl.text('Play');
			$playerCtl.removeClass('playing').addClass('paused');
			$video.isPlaying = false;
			if(!self.autoplay && self.bgVideo){
				$video_box.find('video').css({
					'visibility': 'hidden',
					'opacity': '0'
				});
			}
			// Sync thumbnail button
			var slideIndex = $videoWrapper.closest('.image-slide').data('index');
			if (slideIndex) {
				$('.image-thumbnail[data-index=' + slideIndex + '] .video-ctl-thumbnail').removeClass('playing').addClass('paused');
			}
			has_paused = true;
			console.log('Video paused!');
		});

		const observer = new window.IntersectionObserver(([entry]) => {
				if (entry.isIntersecting) {
					is_inview = true;
					// console.log('ENTER video elem')
					// console.log(`Can play: ${can_play}, Metadata loaded: ${metadata_loaded}`);
					if (self.autoplay && can_play && metadata_loaded && !$video.isPlaying && !has_paused) {
						theVideo.play();
					}
					return
				}
				is_inview = false;
				// console.log('LEAVE video elem')
			}, {
				root: null,
				threshold: 0.1, // set offset 0.1 means trigger if atleast 10% of element in viewport
			}
		)
		observer.observe(theVideo);

		function toggleVideo(){
			if ($video.isPlaying) {
				theVideo.pause();
			} else {
				theVideo.play();
			}
		}

		$video.on('click', function(){
			if(videoSection!="module-video")
			{
				toggleVideo();
			}
		});

		$video_box.on('click', function(e){
			$video_box.find('.content-wrapper').show();
			e.stopPropagation();
			hideControls();
		});

		$video_box.on('mouseover',function(e){
			if(!self.isMobile())
			{
				$video_box.find('.content-wrapper').show();
				e.stopPropagation();
				hideControls();
			}
		});

		$video_box.on('mouseleave',function(){
			hideControls();
		}); 

		function hideControls(){
			setTimeout(function(){
				$video_box.find('.content-wrapper').fadeOut(3000);
			},5000);
			
		}
		
		if ($playerCtl.length) {
			$playerCtl.text('Pause');
			// $playerCtl.removeClass('paused').addClass('playing');
			$playerCtl.on('click', function(e){
				e.preventDefault();
				e.stopPropagation();
				toggleVideo();
			});
		}
		
		$video.on('bufferend', function(){
			console.log("video buffered");
			if (self.isResponsive) {
				responsive(videoRatio);
			}
			console.log('init video');
		});
		
		if (self.isResponsive) {
			$(window).resize(function() {
				clearTimeout(id);
				id = setTimeout(function(){
					responsive(videoRatio);
				}, 400);
			});
		}
	},
	
	loadVimeoPlayer: function(video_id,video_src,$video_box,video_box_id){
		var self = this, id = '', $videoWrapper = $video_box;
		var videoRatio = $videoWrapper.data('ratio') ? $videoWrapper.data('ratio') : 0.6; // 0.6 is default for product video
		var $playerCtl = $videoWrapper.siblings('.video-ctl');
		var responsive = function(r){
			var wrapperRatio = $videoWrapper.width()/$videoWrapper.height();
			// console.log(wrapperRatio + '/' + r);
			if (wrapperRatio >= r) {
				$videoWrapper.find('iframe').css({
					'width' : '100%',
					'height': $videoWrapper.width()/r
				});
			} else {
				$videoWrapper.find('iframe').css({
					'height' : '100%',
					'width': $videoWrapper.height()*r
				});
			}
		};
		
		if (self.isMobile()) {
			var options = {
				// id: video_id,
				byline: false,
				portrait: false,
				title: false,
				loop: false,
				background: true
			};
			var vmplayer = new Player(video_box_id, options);
		} else {
			var $iframe = $('<iframe frameborder="0" src="' + video_src + '?title=0&amp;byline=0&amp;portrait=1&amp;autoplay=1&amp;loop=1&amp;controls=0&amp;background=1">');
			$video_box.html($iframe);
			var vmplayer = new Player($iframe); 
		}
		
		if ($playerCtl.length) {
			
			if (!self.isMobile()) {
				$playerCtl.text('Pause');
				$playerCtl.removeClass('paused').addClass('playing');
				$playerCtl.on('click', function(){
					if (vmplayer.isPlaying) {
						vmplayer.pause();
						$playerCtl.text('Play');
						$playerCtl.removeClass('playing').addClass('paused');
					} else {
						vmplayer.play();
						$playerCtl.text('Pause');
						$playerCtl.removeClass('paused').addClass('playing');
					}
				})
			} else {
				$playerCtl.text('Play');
				$playerCtl.removeClass('playing').addClass('paused');
				$playerCtl.on('click', function(){
					if (vmplayer.isPlaying) {
						vmplayer.pause();
					}
					vmplayer.play();
				})
			}
			
		}
		
		vmplayer.setVolume(0);
		vmplayer.on('play', function() {
			vmplayer.isPlaying = true;
			if (self.isMobile()) {
				$video_box.find('iframe').css({
					'opacity' : '1'
				})
				$playerCtl.css({
					'z-index' : '3'
				});
				$playerCtl.text('Pause');
				$playerCtl.removeClass('paused').addClass('playing');
			}
			console.log('played vm video!');
		});
		vmplayer.on('pause', function() {
			vmplayer.isPlaying = false;
			if (self.isMobile()) {
				$video_box.find('iframe').css({
					'opacity' : '0'
				});
				$playerCtl.text('Play');
				$playerCtl.removeClass('playing').addClass('paused');
			}
			console.log('pause vm video!');
		});
		vmplayer.on('loaded', function() {
			if (self.isResponsive) {
				responsive(videoRatio);
			}
			console.log('init vm video');
		});
		
		if (self.isResponsive) {
			$(window).resize(function() {
				clearTimeout(id);
				id = setTimeout(function(){
					responsive(videoRatio);
				}, 400);
			});
		}
	},
	
	destroy: function() {
		var self = this;
		self.undelegateEvents();
	},

	isMobile: function () {
		if ( ORW.responsive == 'small') {
			return true;
		}
		return false;
	},

	isDesktop: function () {
		if ( ORW.responsive == 'large') {
			return true;
		}
		return false;
	}
	
});

// Define the module here 
let OneVideo = {
	init: function (settings) {
		return new OneVideoView(settings);
	}
}

// Output the module
export default OneVideo;